const TEAM_INFO = [
  {
    name: "BARNEY",
    img: "assets/profiles/sBARN.png",
    position: "Founder",
    description:
      "Just a dude who wants to change the world in any way possible.",
  },
  {
    name: "KESHA",
    img: "assets/profiles/sKESHA.png",
    position: "Co-Founder",
    description:
      "NFT & Web3 enthusiast. This journey is exciting and full of surprises, so I’m making sure we all enjoy the ride together. We Got This #WAGMI.",
  },
  {
    name: "IKIGAI",
    img: "assets/profiles/sIKI.png",
    position: "Co-Founder / Advisor",
    description: "I work out to eat.",
  },
  {
    name: "TIMMIE",
    img: "assets/profiles/STIMM.png",
    position: "Artist",
    description:
      "To whoever needs to hear this: life does get better, hang in there.",
  },
  {
    name: "TEAPHANIE",
    img: "assets/profiles/stEP.png",
    position: "Head Moderator",
    description: "Don't ask me about tea.",
  },
  {
    name: "CHAZ",
    img: "assets/profiles/sCHAZ.png",
    position: "Advisor",
    description:
      "I like making sure Barney doesn’t get in trouble + Web3 enthusiast excited for the possibilities and experiences in this journey.",
  },
];

export { TEAM_INFO };
